var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.94 10 4.47 5.53l1.06-1.06L10 8.94l4.47-4.47 1.06 1.06L11.06 10l4.47 4.47-1.06 1.06L10 11.06l-4.47 4.47-1.06-1.06z",
    clipRule: "evenodd"
  })));
};
export { SvgCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC45MzkzNCAxMC4wMDAxTDQuNDY5NjcgNS41MzAzOUw1LjUzMDMzIDQuNDY5NzNMMTAgOC45Mzk0TDE0LjQ2OTcgNC40Njk3M0wxNS41MzAzIDUuNTMwMzlMMTEuMDYwNyAxMC4wMDAxTDE1LjUzMDMgMTQuNDY5N0wxNC40Njk3IDE1LjUzMDRMMTAgMTEuMDYwN0w1LjUzMDMzIDE1LjUzMDRMNC40Njk2NyAxNC40Njk3TDguOTM5MzQgMTAuMDAwMVoiIC8+Cjwvc3ZnPgo=";